import Vue from "vue";
import VueRouter from "vue-router";
import Cookies from "js-cookie";

Vue.use(VueRouter);

const routes = [
    {
        path: "/insure/detail",
        component: () => import("@/views/insure/detail"),
        meta: {
            title: "产品详情",
            icon: "el-icon-setting"
        },
        hidden: true
    },
    {
        path: "/insure/fillIn",
        component: () => import("@/views/insure/fillIn"),
        meta: {
            title: "投保页面",
            icon: "el-icon-setting"
        },
        hidden: true
    },
    {
        path: "/insure/uploadData",
        component: () => import("@/components/insureFlow/one/uploadData"),
        meta: {
            title: "上传投保资料",
            icon: "el-icon-setting"
        },
        hidden: true
    },
    {
        path: "/insure/pay",
        component: () => import("@/components/insureFlow/one/pay"),
        meta: {
            title: "支付保费",
            icon: "el-icon-setting"
        },
        hidden: true
    },
    {
        path: "/insure/paySuccess",
        component: () => import("@/components/paySuccess"),
        meta: {
            title: "支付成功",
            icon: "el-icon-setting"
        },
        hidden: true
    },
    {
        path: "/hr/insure/paySuccess",
        component: () => import("@/components/paySuccess/hr"),
        meta: {
            title: "支付成功",
            icon: "el-icon-setting"
        },
        hidden: true
    },
    {
        path: "/announce",
        component: () => import("@/views/announce"),
        meta: {
            title: "信息披露",
            icon: "el-icon-setting"
        },
        hidden: true
    },
    {
        path: "/",
        component: () => import("@/layout"),
        redirect: "/list",
        meta: { title: "产品列表", icon: "el-icon-setting" },
        children: [
            {
                path: "/list",
                name: "list",
                component: () => import("@/views/personalCenter/list"),
                meta: { title: "产品列表", icon: "iconfont icon-gongzuotai" }
            }
        ]
    },
    {
        path: "/guarantee",
        component: () => import("@/layout"),
        redirect: "/guarantee",
        meta: { title: "保单记录", icon: "el-icon-setting" },
        children: [
            {
                path: "/guarantee",
                name: "guarantee",
                component: () => import("@/views/personalCenter/guarantee"),
                meta: { title: "保单记录", icon: "iconfont icon-moban" },
                children: [
                    {
                        path: "/guarantee/details",
                        name: "guaranteeDetails",
                        component: () => import("@/views/personalCenter/guarantee/details"),
                        meta: { title: "保单详情", icon: "el-icon-setting" },
                        children: [
                            {
                                path: "/guarantee/check",
                                name: "guaranteeCheck",
                                component: () =>
                                    import("@/views/personalCenter/guarantee/check"),
                                meta: { title: "申请批改", icon: "el-icon-setting" }
                            }
                        ]
                    }
                ]
            }
        ]
    },
    {
        path: "/check",
        component: () => import("@/layout"),
        redirect: "/check",
        meta: { title: "批改记录", icon: "el-icon-setting" },
        children: [
            {
                path: "/check",
                name: "check",
                component: () => import("@/views/personalCenter/check"),
                meta: { title: "批改记录", icon: "iconfont icon-weituo" },
                children: [
                    {
                        path: "/check/details",
                        name: "checkDetails",
                        component: () => import("@/views/personalCenter/check/details"),
                        meta: { title: "批改详情", icon: "el-icon-setting" },
                        children: [
                            {
                                path: "/check/upData",
                                name: "checkUpData",
                                component: () =>
                                    import("@/views/personalCenter/check/uploadData"),
                                meta: { title: "上传资料", icon: "el-icon-setting" }
                            },
                            {
                                path: "/check/pay",
                                name: "checkPay",
                                component: () => import("@/views/personalCenter/check/pay"),
                                meta: { title: "批改支付", icon: "el-icon-setting" }
                            }
                        ]
                    }
                ]
            }
        ]
    },
    {
        path: "/yh/order",
        component: () => import("@/layout"),
        redirect: "/yh/order",
        meta: { title: "产品列表", icon: "el-icon-setting" },
        children: [
            {
                path: "/yh/order",
                name: "yhOrder",
                component: () => import("@/views/yh/index"),
                meta: { title: "到期保单提醒", icon: "iconfont icon-gongzuotai" }
            },
        ]
    },
    {
        path: "/yh/data",
        component: () => import("@/layout"),
        redirect: "/yh/data",
        meta: { title: "产品列表", icon: "el-icon-setting" },
        children: [
            {
                path: "/yh/data",
                name: "yhData",
                component: () => import("@/views/yh/data"),
                meta: { title: "业绩统计", icon: "iconfont icon-gongzuotai" }
            }
        ]
    },
    /* {
        path: "/yh-external", // 保持一个唯一的内部路径
        component: () => import("@/layout"),
        meta: { title: "公司数据大屏", icon: "el-icon-setting" },
        children: [
            {
                path: "http://data.ruilukeji.com/index.html#/data?nameFlag=1", // 替换为你的目标域名地址
                name: "yhGsData",
                meta: { 
                    title: "公司数据大屏", 
                    icon: "iconfont icon-gongzuotai",
                    isExternal: true, // 自定义属性，方便菜单组件识别
                    target: "_blank"  // 明确标识新窗口打开
                }
            }
        ]
    },
    {
        path: "/yh-zyb-external", // 保持一个唯一的内部路径
        component: () => import("@/layout"),
        meta: { title: "直营部数据大屏", icon: "el-icon-setting" },
        children: [
            {
                path: "http://data.ruilukeji.com/index.html#/zyb?nameFlag=1", // 替换为你的目标域名地址
                name: "yhZybData",
                meta: { 
                    title: "直营部数据大屏", 
                    icon: "iconfont icon-gongzuotai",
                    isExternal: true, // 自定义属性，方便菜单组件识别
                    target: "_blank"  // 明确标识新窗口打开
                }
            }
        ]
    }, */
    {
        path: "/yh/employee",
        component: () => import("@/layout"),
        redirect: "/yh/employee",
        meta: { title: "产品列表", icon: "el-icon-setting" },
        children: [
            {
                path: "/yh/employee",
                name: "yhEmployee",
                component: () => import("@/views/yh/employee"),
                meta: { title: "人员查询", icon: "iconfont icon-gongzuotai" }
            }
        ]
    },
    {
        path: "/user",
        component: () => import("@/layout"),
        redirect: "/user/channel",
        meta: { title: "个人账户", icon: "el-icon-setting" },
        children: [
            {
                path: "/user/personal",
                name: "/user/personal",
                component: () => import("@/views/personalCenter/user/personal"),
                meta: {
                    title: "个人资料",
                    icon: "iconfon icon-a-goumaicaigouhuishouhuigourenminbi"
                }
            },
            {
                path: "/user/channel",
                name: "/user/channel",
                component: () => import("@/views/personalCenter/user/channel"),
                meta: {
                    title: "渠道维护",
                    icon: "iconfon icon-a-goumaicaigouhuishouhuigourenminbi"
                }
            },
            {
                path: "/user/eSignature",
                name: "/user/eSignature",
                component: () => import("@/views/personalCenter/user/eSignature"),
                meta: {
                    title: "电子签章",
                    icon: "iconfon icon-a-goumaicaigouhuishouhuigourenminbi"
                }
            }
        ]
    },
    {
        path: "/hr",
        component: () => import("@/layout"),
        redirect: "/hr/list",
        meta: { title: "服务列表", icon: "el-icon-setting" },
        children: [
            {
                path: "/hr/list",
                name: "hrlist",
                component: () => import("@/views/HR/list"),
                meta: { title: "服务列表", icon: "iconfont icon-gongzuotai" },
                children: [
                    {
                        path: "/hr/list/detail",
                        name: "hrdetail",
                        component: () => import("@/views/HR/list/detail"),
                        meta: { title: "产品详情", icon: "iconfont icon-gongzuotai" }
                    }
                ]
            }
        ]
    },
    {
        path: "/hr/staff",
        component: () => import("@/layout"),
        redirect: "/hr/staff",
        meta: { title: "人员清单", icon: "el-icon-setting" },
        children: [
            {
                path: "/hr/staff",
                name: "hrstaff",
                component: () => import("@/views/HR/staffList"),
                meta: { title: "人员清单", icon: "iconfont icon-gongzuotai" },
                children: [
                    {
                        path: "/hr/staff/detail",
                        name: "hrstaffdetail",
                        component: () => import("@/views/HR/staffList/detail"),
                        meta: { title: "订单详情", icon: "iconfont icon-gongzuotai" },
                        children: [
                            {
                                path: "/hr/staff/check",
                                name: "hrCheck",
                                component: () => import("@/views/HR/staffList/check"),
                                meta: { title: "申请批改", icon: "el-icon-setting" }
                            }
                        ]
                    }
                ]
            }
        ]
    },
    {
        path: "/hr/staffChange",
        component: () => import("@/layout"),
        redirect: "/hr/staffChange",
        meta: { title: "人员维护", icon: "el-icon-setting" },
        children: [
            {
                path: "/hr/staffChange",
                name: "staffChange",
                component: () => import("@/views/HR/change"),
                meta: { title: "人员维护", icon: "iconfont icon-gongzuotai" },
                children: [
                    {
                        path: "/hr/staffChange/detail",
                        name: "staffChangeDetail",
                        component: () => import("@/views/HR/change/detail"),
                        meta: { title: "订单详情", icon: "iconfont icon-gongzuotai" },
                        children: [
                            {
                                path: "/hr/staffChange/pay",
                                name: "changeCheckPay",
                                component: () => import("@/views/HR/change/pay"),
                                meta: { title: "批改支付", icon: "el-icon-setting" }
                            }
                        ]
                    }
                ]
            }
        ]
    },
    {
        path: "/hr/insure",
        name: "hrinsure",
        component: () => import("@/views/HR/insure"),
        meta: { title: "投保页面" },
        hidden: true
    },
    {
        path: "/hr/insure/pay",
        name: "hrinsurePay",
        component: () => import("@/views/HR/insure/pay"),
        meta: { title: "支付保费" },
        hidden: true
    },
    {
        path: "/login",
        component: () => import("@/views/login/index"),
        hidden: true
    },
    {
        path: "/signet/ident",
        component: () => import("@/views/signet/ident.vue"),
        name: "ident",
        meta: {
            title: "锐鹿保---企业认证"
        },
        hidden: true
    },
    {
        path: "/signet/apply",
        component: () => import("@/views/signet/apply.vue"),
        name: "apply",
        meta: {
            title: "锐鹿保---电子签申请"
        },
        hidden: true
    },
    {
        path: "/signet/create",
        component: () => import("@/views/signet/create.vue"),
        name: "create",
        meta: {
            title: "锐鹿保---生成电子签"
        },
        hidden: true
    },
    {
        path: "/404",
        component: () => import("@/views/404"),
        hidden: true
    },
    { path: "*", redirect: "/404", hidden: true }
];

const router = new VueRouter({
    routes
});
router.beforeEach((to, from, next) => {
    if (Cookies.get("RLPC_TOKEN_Key")) {
        next();
    } else {
        if (to.path === "/login") {
            next();
        } else {
            next({ path: "/login" });
        }
    }
    /*如果本地 存在 token 则 不允许直接跳转到 登录页面*/
    if (to.fullPath == "/login") {
        if (Cookies.get("RLPC_TOKEN_Key")) {
            next({ path: from.fullPath });
        } else {
            next();
        }
    }
    // 设置标题
    if (to.meta.title) {
        document.title = to.meta.title;
    }
    // 判断进入哪个系统
    if (to.path.includes("/hr")) {
        router.app.$options.store.state.headerSelect = "2";
    } else {
        router.app.$options.store.state.headerSelect = "1";
    }
});
// 解决导航栏或者底部导航tabBar中的vue-router在3.0版本以上频繁点击菜单报错的问题。
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err);
};
export default router;
